// Gatsby requirements
import React from 'react'
import { storyblokEditable } from "gatsby-source-storyblok";

// Components
import RichText from "utils/RichTextRenderer"

// Styles
import * as CSS from './PricingTable.module.scss'


const PricingTable = ({ data }) => {

    return (
        <section
            className={`
                ${CSS.section}
                ${'section' + data._uid}
            `}
            style={{backgroundColor: data?.backgroundColor}}
            {...storyblokEditable(data)}
        >

            {data?.css &&
                <style dangerouslySetInnerHTML={{__html:
                    data.css.replaceAll('.section', '.section' + data._uid).replaceAll('.top-text', '.top-text' + data._uid)
                }} />
            }

            <div className={CSS.wrapper}>
                <div className={`
                    ${CSS.richText}
                    ${'top-text' + data._uid}    
                `}>
                    <RichText content={data?.richText} />
                </div>

                <div className={CSS.tableWrapper}>
                    <table>
                        <thead>
                            <tr>
                                {data?.table?.thead?.map((loop, i) => (
                                    <th key={i}>{loop.value}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {data?.table?.tbody?.map((loop, i) => (
                                <tr key={i}>
                                    <th>{loop?.body[0]?.value}</th>
                                    {loop?.body?.slice(1).map((loop2, i2) => (
                                        <td key={i2}>
                                            {loop2.value}
                                            {data?.table?.tbody.length === i + 1 && i2 === 0 &&
                                                <a className="button" href="https://app.talkwithfrida.com/province">Get started</a>
                                            }
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            </div>
        </section>
    )
}

export default PricingTable